import React from 'react';
import { Select, InputNumber } from 'antd';

// 数值区间下拉预设（自定义放最前）
export const RANGE_PRESETS = [
  { value: 'custom', label: '自定义' },
  { value: 'all', label: '不限' },
  { value: '0', label: '0', min: 0, max: 0 },
  { value: '1-100', label: '1 ~ 100', min: 1, max: 100 },
  { value: '101-500', label: '101 ~ 500', min: 101, max: 500 },
  { value: '501-1000', label: '501 ~ 1,000', min: 501, max: 1000 },
  { value: '1001-5000', label: '1,001 ~ 5,000', min: 1001, max: 5000 },
  { value: '5001-10000', label: '5,001 ~ 10,000', min: 5001, max: 10000 },
  { value: '10000+', label: '10,000 以上', min: 10000, max: undefined }
];

// 涨粉量可能为负数
export const GROWTH_PRESETS = [
  { value: 'custom', label: '自定义' },
  { value: 'all', label: '不限' },
  { value: 'negative', label: '负数（<0）', min: undefined, max: -1 },
  { value: '0', label: '0', min: 0, max: 0 },
  { value: '1-100', label: '1 ~ 100', min: 1, max: 100 },
  { value: '101-500', label: '101 ~ 500', min: 101, max: 500 },
  { value: '501-1000', label: '501 ~ 1,000', min: 501, max: 1000 },
  { value: '1001-5000', label: '1,001 ~ 5,000', min: 1001, max: 5000 },
  { value: '5001-10000', label: '5,001 ~ 10,000', min: 5001, max: 10000 },
  { value: '10000+', label: '10,000 以上', min: 10000, max: undefined }
];

// 区间筛选控件：下拉选预设区间，选“自定义”后输入最小/最大值
export default function RangeFilter({ label, presets, preset, min, max, onChange, size }) {
  const current = presets.find(p => p.value === preset) || presets.find(p => p.value === 'all') || presets[0];
  return (
    <div>
      <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 4 }}>{label}</div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
        <Select
          size={size}
          value={current.value}
          style={{ width: current.value === 'custom' ? 110 : '100%' }}
          popupMatchSelectWidth={false}
          options={presets.map(p => ({ label: p.label, value: p.value }))}
          onChange={(v) => {
            const p = presets.find(x => x.value === v) || presets[0];
            onChange({ preset: v, min: p.min, max: p.max });
          }}
        />
        {current.value === 'custom' && (
          <>
            <InputNumber
              size={size}
              placeholder="最小值"
              style={{ width: 90 }}
              value={min}
              onChange={(v) => onChange({ preset: 'custom', min: v })}
            />
            <span style={{ color: '#999' }}>~</span>
            <InputNumber
              size={size}
              placeholder="最大值"
              style={{ width: 90 }}
              value={max}
              onChange={(v) => onChange({ preset: 'custom', max: v })}
            />
          </>
        )}
      </div>
    </div>
  );
}
